import sociosRaw from './socios-cessi.json' with { type: 'json' };
function normalizarBusqueda(texto) {
    return texto
        .normalize('NFD')
        .replace(/\p{M}/gu, '')
        .toLowerCase()
        .trim();
}
/** Nombre habitual para mostrar y persistir (fantasía si existe, si no razón social). */
export function etiquetaSocioCessi(s) {
    const fant = s.nombreFantasia.trim();
    return fant || s.razonSocial.trim();
}
const SOCIOS = sociosRaw;
export const OPCIONES_SOCIOS_CESSI = SOCIOS.map((s) => {
    const razonSocial = s.razonSocial.trim();
    const label = etiquetaSocioCessi(s);
    return {
        value: label,
        label,
        razonSocial,
        busqueda: normalizarBusqueda(`${label} ${razonSocial}`),
    };
}).sort((a, b) => a.label.localeCompare(b.label, 'es'));
const VALORES_SOCIOS = new Set(OPCIONES_SOCIOS_CESSI.map((o) => o.value));
export function esSocioCessiValido(value) {
    return VALORES_SOCIOS.has(value);
}
/** Filtra socios por texto (alfabético, máx. `limit` resultados). */
export function filtrarSociosCessi(query, limit = 12) {
    const q = normalizarBusqueda(query);
    if (!q)
        return OPCIONES_SOCIOS_CESSI.slice(0, limit);
    return OPCIONES_SOCIOS_CESSI.filter((o) => o.busqueda.includes(q)).slice(0, limit);
}
//# sourceMappingURL=socios-cessi.js.map